/* Core & libraries */
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import {
  SETTINGS_FARE_ACCESS__GET_ENDPOINT,
  GET_DISCOUNTTERMS_CONTENT,
  SETTINGS_FARE_ACCESS__PATCH_ENDPOINT
} from "../endpoints/endpoints";
import { useNotificationContext } from "../contexts/notificationContext";
import { useUserContext } from "../contexts/userContext";

export const useFareAccessService = () => {
  const { genericApiFetch } = useGenericApiFetch();
  const { setNotification } = useNotificationContext();
    const userContext = useUserContext();

  const getFareAccessData = async (companyId) => {
    const response = await genericApiFetch({
      url: SETTINGS_FARE_ACCESS__GET_ENDPOINT.replace("{companyId}", companyId),
      method: "GET",
      //spinner: ""
    });

    if (response.success) {
      return response.data;
    }
    return false;
  }

  const postFareAccessData = async (companyEntityId, payload) => {
    const response = await genericApiFetch({
      url: SETTINGS_FARE_ACCESS__PATCH_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "PATCH",
      data: payload,
      spinner: "updateFareAccessSpinner"
    });
    if (response.success) {
      setNotification(
        "success",
        <FormattedMessage id="fareAccess.notification.succesTitle" />,
        <FormattedMessage id="fareAccess.notification.succesMessage" />
      )
      return true
    }
    setNotification(
      "error",
      <FormattedMessage id="fareAccess.notification.errorTitle" />,
      <FormattedMessage id="fareAccess.notification.errorMessage" />
    )
    return false
  };

  const getDiscountTermsContent = async (companyEntityId) => {
    const response = await genericApiFetch({
      url: GET_DISCOUNTTERMS_CONTENT.replace("{companyEntityId}", userContext?.userInfo?.companyInfo?.companyEntityId || companyEntityId),
      method: "GET",
      spinner: "getDiscountTermsSpinner"
    });

    if (response.success) {
      return response.data;
    }

    setNotification(
      "error",
      <FormattedMessage id="discountterms.notification.errorTitle" />,
      <FormattedMessage id="discountterms.notification.errorMessage" />
    );

    return null;
  };

  return {
    getFareAccessData,
    postFareAccessData,
    getDiscountTermsContent
  };
}